"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var theme_1 = require("../../theme");
var withStyles_1 = __importDefault(require("@material-ui/core/styles/withStyles"));
var StyledTabs = withStyles_1.default({
    root: {
        overflow: 'visible'
    },
    fixed: {
        overflow: 'visible !important'
    },
    indicator: {
        display: 'none'
    },
})(core_1.Tabs);
var styles = function (theme) {
    var _a, _b;
    return core_1.createStyles({
        '@global': {
            // CSS for Selected Tab. Global because unable to select through JSS selectors.
            '.MuiTab-textColorPrimary.Mui-selected': {
                backgroundColor: theme_1.colors.grey[100],
                '@media (hover:hover)': {
                    '&:hover': {
                        backgroundColor: theme_1.colors.blue[50],
                    },
                },
                boxShadow: '0 5px 22px 4px rgba(0, 32, 64, 0.06), 0 12px 17px 2px rgba(0, 32, 64, 0.08)',
            },
        },
        tab: (_a = {
                fontWeight: 500,
                borderRadius: theme.spacing(1.5, 1.5, 0, 0),
                padding: theme.spacing(1.5, 1.5, .5, 1.5),
                margin: theme.spacing(0, 0, 0, 1)
            },
            _a[theme.breakpoints.up('md')] = {
                minWidth: theme.spacing(16)
            },
            _a['&:hover'] = {
                backgroundColor: theme_1.colors.blue[50],
            },
            _a['text-transform'] = 'inherit',
            _a),
        divider: (_b = {
                height: theme.spacing(1),
                backgroundImage: 
                // 2 linear gradients, combined
                // colors: transparent=rgba(244, 248, 252, 0), grey[100]=rgba(244,248,252,1)
                // 1. grey[100] at bottom, transparent at top
                // 2. grey[100] in middle, transparent on sides
                "linear-gradient(to bottom, rgba(244,248,252,1), rgba(244, 248, 252, 0))," +
                    "linear-gradient(90deg, rgba(244,248,252,1) 0%, rgba(244,248,252,0) 25%, rgba(244,248,252,1) 100%)",
                backgroundColor: 'rgba(0, 32, 64, 0.13)',
                margin: theme.spacing(-1, 25, 0, -25)
            },
            _b[theme.breakpoints.down('sm')] = {
                margin: theme.spacing(-1, -2, 0, -2)
            },
            _b),
        tabPanel: {
            position: 'relative',
            backgroundColor: theme.palette.grey[100],
            margin: theme.spacing(0, -2),
            padding: theme.spacing(0, 2)
        }
    });
};
var Tabs = withStyles_1.default(styles)(function (_a) {
    var items = _a.items, tabChangeEvent = _a.tabChangeEvent, currentTab = _a.currentTab, classes = _a.classes;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledTabs, { value: currentTab, onChange: tabChangeEvent, textColor: 'primary' }, items.map(function (_a, index) {
            var name = _a.name, tabProps = _a.tabProps;
            return (react_1.default.createElement(core_1.Tab, __assign({ className: classes.tab, key: index, disableRipple: true, label: react_1.default.createElement(Typography_1.default, { variant: 'body2', color: 'primary' }, name) }, tabProps)));
        })),
        react_1.default.createElement(Divider_1.default, { className: classes.divider }),
        react_1.default.createElement(core_1.Box, { className: classes.tabPanel, role: "tabpanel" }, items[currentTab].tabContent)));
});
exports.default = Tabs;
